import { lightColors } from '@/plugins/colors/base/baseColorsLight'
import textTokensLight from '@/plugins/colors/tokens/light/sections/text'

const tagTokensLight = {
  'tag-gray-background-default': lightColors.gray['50'],
  'tag-gray-background-hover': lightColors.gray['700'],
  'tag-gray-foreground-default': lightColors.gray['800'],
  'tag-brand-background-default': lightColors.brand['500'],
  'tag-brand-background-hover': lightColors.brand['700'],
  'tag-brand-foreground-default': lightColors.gray.white,
  'tag-success-background-default': lightColors.green['500'],
  'tag-transparent-tag-success-background-default': lightColors.green['50'],
  'tag-transparent-tag-success-foreground-default': lightColors.green['700'],
  'tag-success-background-hover': lightColors.green['700'],
  'tag-success-foreground-default': textTokensLight['text-white'],
  'tag-error-background-default': lightColors.red['500'],
  'tag-error-background-hover': lightColors.red['700'],
  'tag-error-foreground-default': textTokensLight['text-white'],
  'tag-warning-background-default': lightColors.orange['500'],
  'tag-warning-background-hover': lightColors.orange['700'],
  'tag-warning-foreground-default': textTokensLight['text-white'],
  'tag-info-background-default': lightColors.blue['500'],
  'tag-info-background-hover': lightColors.blue['700'],
  'tag-info-foreground-default': textTokensLight['text-white']
}

export default tagTokensLight
